export const translator = {
    date_derniere_note: 'date_latest_evaluation',
    date_naissance_candidat: 'birth_date',
    date_premiere_affectation: 'first_appointment_date',
    date_titularisation: 'demarcation_date',
    date_affectation_etab: 'actual_institution_appointment_date',
    date_affectation_centre: 'work_center_appointment_date',
    date_affectation_cre: 'regional_commissary_appointment_date',
    id_grade_candidat: 'grade',
    confirm_delete_dialog: 'confirm_delete_dialog',
    date_mariage: 'marriage_date',
    date_nomination_fonction: 'position_appointment_date',
    date_derniere_note_pedagogique: 'date_latest_educational_mark',
    date_creation: 'creation_date',
    nom_conjoint: 'spouse_last_name',
    prenom_conjoint: 'spouse_first_name',
    rcDelegation: 'delegation',
    derniere_note_pedagogique: 'latest_educational_mark',
    nb_enfant_handicape: 'children_number_with_a_disability',
    derniere_annee: 'date_latest_evaluation',
    anc_insp_a: 'anc_insp_a',
    anc_insp_c: 'anc_insp_c',
    anc_insp_p: 'anc_insp_p',
    anc_insp_g: 'anc_insp_g',
    nb_jours_coupure: 'nb_jours_coupure',
    nb_mois_coupure: 'nb_mois_coupure',
    nb_annee_coupure: 'nb_annee_coupure',
    rcEstablishment: 'institution',
    rcSpecialite: 'speciality',
    rsSexe: 'gender',
    rcGrade: 'grade',
    nmbre_anciennete_enseignement: 'seniority_in_education',
    id_fonction: 'job',
    id_sanction: 'categorie_sanction',
    nb_annee_eloignement: 'years_away_from_spouse',
    conjoint_min_educ: 'spouse_in_education_field',
    rcFonction: 'job',
    specialite_candidat: 'speciality',
    etablissement_actuel: 'institution',
    nom_candidat: 'last_name',
    prenom_candidat: 'first_name',
    derniere_note: 'latest_administrative_mark',
    type_affect: 'assignment_type',
    duree_interruption: 'interruption_duration',
    n_rue_adresse_conjoint: 'spouse_address',
    emploi_conjoint: 'spouse_profession',
    nb_enfant_charge: 'children_number_in_charge',
    anciennete_dir_epp: 'anciennte_dir',
    travail_classe: 'travail_classe',
    note_administrative: 'note_administrative',
    etat_civil: 'civil_status',
    adresse: 'address',
    nb_sanction: 'number_of_sanctions',
    id_corps: 'sector',
    years_away_from_spouse: 'nb_annee_eloignement',
    rcSousSituationAdmin: 'administrative_status',
    rcSituationAdmin: 'sub_administrative_status',
    id_conjoint: 'spouse_id',
    id_delegation: 'delegation',
    id_grade_recrutement: 'grade_upon_recruitment',
    date_modification: 'update_date',
    nb_distance_eloignement: 'distance_from_spouse',
    libelleMvt: 'wording',
    codeMvt: 'code',
    nbChoixMin: 'minimum_threshold',
    nbChoixMax: 'maximum_threshold',
    nbChoixCre: 'regional_commissary_choices',
    url: 'url',
    description: 'description',
    dateDebutDepot: 'deposit_start_date',
    dateFinDepot: 'deposit_end_date',
    dateOuverture: 'opening_date',
    dateCloture: 'closing_date',
    dateReference: 'reference_date',
    anneeScolaire: 'school_year',
    flg_titularisation: 'is_appointed_to_a_permanent_post',
    nom: 'last_name',
    prenom: 'first_name',
    dateDebut: 'start_date',
    dateFin: 'end_date',
    idCre: 'regional_commissary',
    nombrePostes: 'vacancies_number',
    nombrePostesRes: 'remaining_positions',
    idSpecialite: 'speciality',
    idMvt: 'movement',
    typeCentreAffect: 'work_center_type',
    candidat: 'educator',
    admin: 'administrator',
    Agent_CRE: 'Agent CRE',
    Administrateur: 'Administrateur',
    Gestionnaire_central: 'Gestionnaire_central',
    Administrateur_regional: 'Administrateur_regional',
    Gestionnaire_CRE: 'Gestionnaire CRE',
    Pilote: 'Pilote',
    validateur: 'validator',
    periodique: 'periodic',
    date_recrutement_corps: 'sector_recruitment_date',
    date_titularisation_corps: 'sector_demarcation_date',
    date_deb_contrat: 'start_date_of_contract',
    date_fin_contrat: 'end_date_of_contract',
    date_cin: 'national_id_delivery_date',
    dateGradeActuel: 'actual_grade_date',
    dateSousSituation: 'administrative_status_assignment_date',
    idGouvernoratNaissance: 'hometown_state',
    sexe: 'gender',
    rcSituationGrade: 'adjective',
    situationGrade: 'adjective',
    idNationalite: 'nationality',
    NumeroTelPortable: 'phone_number',
    adresseScolaire: 'address',
    numeroTelScolaire: 'phone_number',
    codePostalScolaire: 'postal_code',
    idGouvernoratScolaire: 'state',
    idDelegationScolaire: 'delegation',
    nbEnfant: 'children_number',
    adresseVacance: 'address_in_vacancy',
    numeroTelVacance: 'phone_number_in_vacancy',
    codePostalVacance: 'postal_code_in_vacancy',
    idDelegationVacance: 'delegation_in_vacancy',
    idGouvernoratVacance: 'state_in_vacancy',
    code_postal_conjoint: 'spouse_postal_code',
    id_delegation_conjoint: 'spouse_delegation',
    idGouvernoratConjoint: 'spouse_state',
    adresseConjoint: 'spouse_address',
    lieuEmploiConjoint: 'spouse_job',
    nomJeuneFilleConjoint: 'spouse_last_name_before_marriage',
    idDiplome: 'diploma',
    Specialitediplome: 'diploma_speciality',
    origineDiplome: 'diploma_origin',
    id_sous_situation_admin: 'sub_administrative_status',
    heuresEnseignement: 'teaching_hours',
    idNatureTravail: 'work_type',
    flgSpecialiste: 'specialist',
    actif: 'is_active',
    inactif: 'is_inactive',
    verouillé: 'is_locked',
    lieuNaissance: 'birth_place',
    anciennete_directeur: 'anciennte_directeur',
    anciennete_assistant_ped: 'anciennete_assistant_ped',
    moyenne_note_deux_derniere_note: 'moyenne_note_deux_derniere_note',
    bonification_special_anciennete_general:
        'bonification_special_anciennete_general',
    anciennete_general: 'anciennete_general',
    date_affectation_centre_code: 'date_affectation_centre_code',
    bonification_anciennete_etab_actuel: 'bonification_anciennete_etab_actuel',
    date_affectation_cre_code: 'date_affectation_cre_code',
    date_affectation_etab_code: 'date_affectation_etab_code',
    date_naissance_candidat_code: 'date_naissance_candidat_code',
    date_nomination_fonction_code: 'date_nomination_fonction_code',
    date_premiere_affectation_college_lycee:
        'date_premiere_affectation_college_lycee',
    date_premiere_affectation_primaire: 'date_premiere_affectation_primaire',
    bonification_anciennete_general: 'bonification_anciennete_general',
    derniere_note_inspection: 'derniere_note_inspection',
    derniere_note_pedagogique_code: 'derniere_note_pedagogique_code',
    nb_annee_eloignement_code: 'nb_annee_eloignement_code',
    nb_distance_eloignement_code: 'nb_distance_eloignement_code',
    nb_distance_eloignement_50: 'nb_distance_eloignement_50',
    anciennete_travail_periodique: 'anciennete_travail_periodique',
    anciennete_censeur: 'anciennete_censeur',
    note_directeur_primaire: 'note_directeur_primaire',
    date_affect_admin: 'date_affect_admin',
    anciennete_ecole_app: 'anciennete_ecole_app',
    anciennete_assistant_dir: 'anciennete_assistant_dir',
    flg_ecole_pp: 'flg_ecole_pp',
    date_affectation_cre_bonus: 'date_affectation_cre_bonus',
    id_gouvernorat_ens_enf: 'id_gouvernorat_ens_enf',
    id_gouvernorat_conjoint: 'id_gouvernorat_conjoint',
    rcEtatCivil: 'civil_status',
    delegationConjoint: 'spouse_delegation',
    gouvernoratNaissance: 'hometown_state',
    rcNationalite: 'nationality',
    cin: 'cin',
    email: 'email',
    rcSexe: 'gender',
    rcGradeRecrutement: 'grade_upon_recruitment',
    rcEtablissement: 'actual_establishment',
    rcDiplome: 'diploma',
    delegationScolaire: 'scolar_delegation',
    gouvernoratScolaire: 'scolar_state',
    delegationVacance: 'delegation_in_vacancy',
    gouvernoratVacance: 'gouvernorat_in_vacancy',
    gouvernoratConjoint: 'id_gouvernorat_conjoint',
    rcNatureTravail: 'work_type',
    rcTypeAffectation: 'type_affectation',
    identifiant_conjoint: 'identifiant_conjoint'
};
